import React from "react";
import { Fade } from "react-awesome-reveal";

import styles from "./votercard.module.css";

type HoverIconsProps = {
  onEdit?: () => void;
  onView?: () => void;
  onDelete?: () => void;
};

function HoverVoterCardIcon({ onEdit, onView, onDelete }: HoverIconsProps) {
  return (
    <>
      <div className="absolute right-0 top-1/2 -translate-y-1/2 ">
        <Fade duration={1500}>
          <div
            className={`p-[6px] rounded-tl-[28px] rounded-bl-[28px] ${styles["bg-hover-icon"]} space-y-2`}
          >
            {/* View Icon (optional) */}
            {onView && (
              <div
                className={`${styles["hover-card-icon"]} flex items-center justify-center`}
                onClick={onView}
              >
                <i className="fa-regular fa-eye text-sm" />
              </div>
            )}

            {onEdit && (
              <div
                className={`${styles["hover-card-icon"]} flex items-center justify-center`}
                onClick={onEdit}
              >
                <i className="fa-regular fa-pen-to-square text-sm" />
              </div>
            )}

            {/* Delete Icon (optional) */}
            {onDelete && (
              <div
                className={`${styles["hover-card-icon"]} flex items-center justify-center`}
                onClick={onDelete}
              >
                <i className="fa-regular fa-trash-can text-sm" />
              </div>
            )}
          </div>
        </Fade>
      </div>
    </>
  );
}

export default HoverVoterCardIcon;
